module.exports = __webpack_public_path__ + "img/joinZigZagWhite.42065d22.svg";